import { Request } from '@/classes/Request.ts'

export interface EnrollmentPortalDeviceProofResponse {
  success: boolean
  failure_reason?: string
  data?: {
    device_proof: string | null
    device_proof_expires_at: string | null
  }
}

/**
 * SOW-300: a signed-in family's session stands in for the invitation's email code.
 * Core mints this device's proof for the family's OWN invitation (422 for anyone
 * else's), and the embed page hands it to the forms-engine iframe so the family is
 * not asked for a code on top of their login.
 * POST /ajax/enrollment/invitation/{token}/device-proof
 */
export const enrollmentPortalDeviceProof = async (
  token: string
): Promise<EnrollmentPortalDeviceProofResponse> => {
  const response = await new Request().post(
    `/ajax/enrollment/invitation/${encodeURIComponent(token)}/device-proof`
  )
  return response.data
}
